module.exports = __webpack_public_path__ + "img/Battery.7e296a32.png";